import React from "react";
import { Sparkles, User, Shield, MapPin } from "lucide-react";

interface HomePageProps {
  setCurrentPage: (page: string) => void;
  setCareerDesignStep: (step: number) => void;
}

const HomePage: React.FC<HomePageProps> = ({
  setCurrentPage,
  setCareerDesignStep,
}) => (
  <div className="p-6">
    {/* 헤더 */}
    <div className="text-center mb-8">
      <h1 className="text-4xl font-bold text-blue-600 mb-2">Flow</h1>
    </div>

    {/* 메인 메뉴 - 선배 추천 1개 */}
    <div className="mb-8">
      <button
        onClick={() => setCurrentPage("recommendation")}
        className="w-full bg-gradient-to-br from-blue-500 to-blue-600 text-white p-8 rounded-2xl shadow-lg hover:shadow-xl transition-all"
      >
        <User className="w-10 h-10 mb-3 mx-auto" />
        <h3 className="font-semibold text-lg">선배 따라가기</h3>
        <p className="text-sm mt-2 opacity-90">AI가 추천하는 맞춤 멘토와 실제 커리어 경로 탐색</p>
      </button>
    </div>

    {/* AI 진로 설계 배너 */}
    <div className="bg-gradient-to-r from-blue-600 to-purple-600 text-white p-6 rounded-2xl mb-6 shadow-lg">
      <div className="flex items-center mb-3">
        <Sparkles className="w-6 h-6 mr-2" />
        <h3 className="text-lg font-bold">AI 맞춤형 진로 설계</h3>
      </div>
      <p className="text-sm mb-4">
        선배들의 실제 경험을 바탕으로 나만의 커리어 로드맵을 만들어보세요
      </p>
      <button
        onClick={() => {
          setCurrentPage("careerDesign");
          setCareerDesignStep(1);
        }}
        className="bg-white text-blue-600 px-6 py-2 rounded-full font-semibold hover:bg-gray-100 transition-colors"
      >
        시작하기 →
      </button>
    </div>

    {/* 개인정보 보호 안내 */}
    <div className="bg-blue-50 p-4 rounded-xl mb-6">
      <div className="flex items-start">
        <Shield className="w-5 h-5 text-blue-600 mr-2 flex-shrink-0 mt-0.5" />
        <div>
          <h4 className="font-semibold text-sm text-blue-900 mb-1">
            개인정보 보호
          </h4>
          <p className="text-xs text-blue-700">
            선배님들의 개인정보는 안전하게 보호되며, 앱 내에서만 소통이
            가능합니다.
          </p>
        </div>
      </div>
    </div>

    {/* 전북 지역 특화 정보 */}
    <div className="bg-gray-50 p-4 rounded-xl">
      <h3 className="font-semibold text-gray-800 mb-2 flex items-center">
        <MapPin className="w-5 h-5 mr-2 text-red-500" />
        전라북도 취업 현황
      </h3>
      <div className="grid grid-cols-3 gap-2 text-center">
        <div className="bg-white p-3 rounded-lg">
          <p className="text-2xl font-bold text-blue-600">847</p>
          <p className="text-xs text-gray-600">이번달 취업자</p>
        </div>
        <div className="bg-white p-3 rounded-lg">
          <p className="text-2xl font-bold text-green-600">92%</p>
          <p className="text-xs text-gray-600">지역 정착률</p>
        </div>
        <div className="bg-white p-3 rounded-lg">
          <p className="text-2xl font-bold text-purple-600">1,234</p>
          <p className="text-xs text-gray-600">활동 선배</p>
        </div>
      </div>
    </div>
  </div>
);

export default HomePage;
